<template>
  <div
    class="md-layout md-alignment-middle-left booking-discount"
    style="margin-top: 1em; align-items:center;"
  >
    <div class="md-layout-item md-size-90" style="margin-top: 1em;">
      <h6 style="margin-bottom:0;">Discount</h6>
    </div>
    <template v-if="!booking.discount">
      <div
        class="md-layout-item md-size-10 text-right"
        style="margin-top: 1em;"
      >
        <md-button
          class="md-icon-button md-dense md-primary md-round"
          @click="showDialog"
        >
          <md-icon>add</md-icon>
        </md-button>
      </div>
    </template>
    <template v-else>
      <div class="md-layout-item md-size-90">
        {{ booking.discount.description }}
      </div>
      <div class="md-layout-item md-size-10 text-right">
        <md-button
          class="md-icon-button md-dense md-danger md-simple"
          @click.stop="removeDiscount"
        >
          <md-icon>clear</md-icon>
          <md-tooltip md-direction="top">Remove this Discount</md-tooltip>
        </md-button>
      </div>
    </template>

    <md-dialog :md-active.sync="showDiscountDialog">
      <md-dialog-title>Discounts</md-dialog-title>
      <div class="md-layout">
        <md-table
          class="md-layout-item md-size-100"
          v-model="availableDiscounts"
          md-card
          @md-selected="onSelect"
        >
          <md-table-row
            slot="md-table-row"
            slot-scope="{ item }"
            md-selectable="single"
          >
            <md-table-cell md-label="Code">{{ item.code }}</md-table-cell>
            <md-table-cell md-label="Description">{{
              item.description
            }}</md-table-cell>
            <md-table-cell md-label="Percentage">{{
              item.amount
            }}</md-table-cell>
          </md-table-row>
        </md-table>
      </div>
      <md-dialog-actions>
        <md-button
          class="md-primary md-dense"
          @click="showDiscountDialog = false"
          >Cancel</md-button
        >
        <md-button
          class="md-primary md-dense"
          @click="addDiscount"
          :disabled="!selectedDiscount"
          >Apply</md-button
        >
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>
<script>
import bookingApi from "@/services/api/booking";
import _filter from "lodash/filter";

export default {
  name: "BookingDiscount",

  props: ["booking"],

  data() {
    return {
      discounts: [],
      showDiscountDialog: false,
      selectedDiscount: null
    };
  },

  computed: {
    availableDiscounts() {
      let currentDiscount = this.booking.discount?.id;
      return _filter(this.discounts, function(discount) {
        return discount.id !== currentDiscount;
      });
    }
  },

  methods: {
    updated() {
      this.$emit("updated");
    },

    showDialog() {
      this.selectedDiscount = null;
      this.showDiscountDialog = true;
    },

    getDiscounts() {
      bookingApi.getDiscounts().then(response => {
        this.discounts = response.data.discounts;
      });
    },

    addDiscount() {
      this.showDiscountDialog = false;
      bookingApi
        .addDiscount(this.booking, this.selectedDiscount)
        .then(response => {
          this.booking.discount = this.selectedDiscount;
          this.updated();
        });
    },

    removeDiscount() {
      bookingApi.removeDiscount(this.booking).then(response => {
        this.booking.discount = null;
        this.updated();
      });
    },

    onSelect(item) {
      this.selectedDiscount = item;
    }
  },

  created() {
    this.getDiscounts();
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";
</style>
